
import { apiCallStatus } from '../../../../../helpers/constants';
import * as actionTypes from './constants';

const initialState = {
	changedParameterFileListV2: {
		data: [],
		loadingStatus: apiCallStatus.LOADING
	}
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_CHANGED_PARAMETER_LIST_V2:
			return {
				...state,
				changedParameterFileListV2: { ...state.changedParameterFileListV2, ...action }
			};
		default:
			return state;
	}
};

export default reducer;

